/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  rootIsFixed: 'rootIsFixed_8e56db62',
  content: 'content_8e56db62',
};

export = styles;

loadStyles([{"rawString":".rootIsFixed_8e56db62{position:fixed;z-index:1000000;top:0;left:0;width:100vw;height:100vh;visibility:hidden}.content_8e56db62{visibility:visible}"}]);
/* tslint:enable */